export const prepareEmptyFilters = (filtersToClear = []) => {
  const emptyFilters = {};
  filtersToClear.forEach((filter) => {
    emptyFilters[filter] = [];
  });
  return emptyFilters;
};
